import axios, { AxiosResponse } from 'axios';

import { GalleryTag } from '../interfaces/gallery-tag.interface';

const galleryTagsEndpoint = 'gallery-tags';

export const fetchGalleryTags = async (baseApiUrl: string): Promise<{ galleryTags: GalleryTag[] }> => {
  const response: AxiosResponse<{ galleryTags: GalleryTag[] }> = await axios.get(`${baseApiUrl}/${galleryTagsEndpoint}`);

  return response.data;
};

export const editGalleryTag = async (baseApiUrl: string, galleryTagId: number, editedGalleryTagName: string): Promise<void> => {
  const response: AxiosResponse<void> = await axios.patch(`${baseApiUrl}/${galleryTagsEndpoint}/${galleryTagId}`, { editedGalleryTagName });

  return response.data;
};

export const restoreGalleryTag = async (baseApiUrl: string, galleryTagId: number, editedGalleryTagName: string): Promise<void> => {
  const response: AxiosResponse<void> = await axios.patch(`${baseApiUrl}/${galleryTagsEndpoint}/${galleryTagId}`, {
    isDeleted: false,
    editedGalleryTagName,
  });

  return response.data;
};

export const deleteGalleryTag = async (baseApiUrl: string, galleryTagIdId: number): Promise<void> => {
  const response: AxiosResponse<void> = await axios.delete(`${baseApiUrl}/${galleryTagsEndpoint}/${galleryTagIdId}`);

  return response.data;
};

export const addNewGalleryTag = async (baseApiUrl: string, newGalleryTag: string): Promise<GalleryTag> => {
  const response: AxiosResponse<GalleryTag> = await axios.post(`${baseApiUrl}/${galleryTagsEndpoint}`, { newGalleryTag });

  return response.data;
};

const galleryTagsAPI = {
  fetchGalleryTags,
  editGalleryTag,
  deleteGalleryTag,
  addNewGalleryTag,
};

export default galleryTagsAPI;
